import { useEffect } from 'react';
// layouts
import Layout from '../../layouts';
//auth
import { useRouter } from 'next/router';
// components
import LoadingScreen from '../../components/LoadingScreen';
import useAuth from '../../hooks/useAuth';

// ----------------------------------------------------------------------
// DEFEITO CORRIGIDO: RootStyle/ContentStyle (styled do MUI) existiam neste
// arquivo mas nunca eram usados no JSX - so a LoadingScreen era renderizada.
// Removidos junto com o import de @mui/material/styles.
// ----------------------------------------------------------------------

IndexPage.getLayout = function getLayout(page) {
  return <Layout variant="main">{page}</Layout>;
};

// ----------------------------------------------------------------------

export default function IndexPage() {

  const { isAuthenticated, setToken, isInitialized } = useAuth();
  const { push,
    //pathname,
   //  query
     } = useRouter();

  // const { token } = query;

  // useEffect(() => {
  //   if(token){
  //     setToken(token)
  //   }
  // }, [token])

  // O redirecionamento MORA NUM useEffect de proposito.
  //
  // Antes as duas linhas abaixo rodavam direto no corpo do componente, ou seja,
  // DURANTE O RENDER. Com o next/router isso passava; com o react-router (que e
  // quem atende o shim de compat) o navigate durante o render gera
  //   "You should call navigate() in a React.useEffect(), not when your component
  //    is first rendered."
  // e, pior, pode ser descartado ou disparar duas vezes - foi essa familia de
  // problema que fazia o login aparecer e voltar. Mesma correcao ja aplicada em
  // pages/index.jsx.
  //
  // A guarda `isInitialized` continua sendo o que evita mandar para o login antes
  // de o contexto de autenticacao terminar de ler o token.
  useEffect(() => {
    if (!isInitialized) return;
    push(isAuthenticated ? '/dashboard/app/' : '/auth/login');
  }, [isInitialized, isAuthenticated, push]);

  return (
    <LoadingScreen />
  );
}
